<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <div class="col-lg-4">
            <yt-dropdown-picklist
              [ModelName]="'podvrstadokumentastavka'"
              [GetName]="'GetByUrl'"
              [ModelProperty]="'Sifra,Naziv'"
              [GetParameters]="[{ Name: 'url', Value: '/kad/resenjezago' }]"
              formControlName="PodvrstaDokumentaStavkaID"
              [Label]="'RESENJEZAGO.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
              [ngClass]="{
                'is-invalid': submitted && fc.PodvrstaDokumentaStavkaID.invalid
              }"
              [Width]="'600px'"
              (OnItemSelected)="onPodVrstaSelect($event)"
              [Required]="IsRequired('PodvrstaDokumentaStavkaID')"
              #autofocus
            >
            </yt-dropdown-picklist>
            <div
              class="form-error"
              *ngIf="submitted && fc.PodvrstaDokumentaStavkaID.invalid"
            >
              <span
                *ngFor="
                  let validation of errorMessages.PodvrstaDokumentaStavkaID
                "
              >
                <span
                  class="error-message"
                  *ngIf="fc.PodvrstaDokumentaStavkaID.hasError(validation.type)"
                >
                  <span translate="{{ validation.message }}"></span>
                </span>
              </span>
            </div>
          </div>

          <div class="col-lg-2">
            <yt-fw-date-picker-popup
              name="dateDatum"
              formControlName="Datum"
              [ngClass]="{ 'is-invalid': submitted && fc.Datum.invalid }"
              [Label]="'RESENJEZAGO.DATUM.SINGULAR'"
            >
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
              <span *ngFor="let validation of errorMessages.Datum">
                <span
                  class="error-message"
                  *ngIf="fc.Datum.hasError(validation.type)"
                  ><span translate="{{ validation.message }}"></span
                ></span>
              </span>
            </div>
          </div>

          <div class="col-lg-2">
            <div class="form-group row">
            <yt-input
              [Type]="'text'"
              [Label]="'RESENJEZAGO.BROJ.SINGULAR'"
              formControlName="BrojDokumenta"
              [ngClass]="{ 'is-invalid': submitted && fc.Broj.invalid }"
              formControlName="Broj"
            >
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Broj.invalid">
              <span *ngFor="let validation of errorMessages.Broj">
                <span
                  class="error-message"
                  *ngIf="fc.Broj.hasError(validation.type)"
                >
                  <span translate="{{ validation.message }}"></span>
                </span>
              </span>
            </div>

            <div class="input-group-append">
              <span class="span-control">/</span>
              <span
                *ngIf="baseFormGroup.get('Datum').value != null"
                class="span-control"
                >{{ baseFormGroup.get("Datum").value.year }}</span
              >
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <!-- Zaposleni -->
      <div class="col-md-12">
        <!-- <yt-dropdown-picklist
          [ModelName]="'zaposleni'"
          [GetName]="'get'"
          [ModelProperty]="'Prezime,Ime'"
          [GetParameters]="modelData.MainList.GetParameters"
          formControlName="OsobaID"
          [Label]="'RESENJEZAGO.OSOBA.SINGULAR'"
        >
        </yt-dropdown-picklist> -->

        <yt-autocomplete
          [ModelName]="'zaposleni'"
          [GetName]="'getByPrezime'"
          [ModelProperty]="'PrezimeIIme'"
          [OrderBy]="'PrezimeIIme'"
          [GetParameters]="modelData.MainList.GetParameters"
          formControlName="OsobaID"
          [Label]="'RESENJEZAGO.OSOBA.SINGULAR'"
        >
        </yt-autocomplete>



        <div class="form-error" *ngIf="submitted && fc.OsobaID.invalid">
          <span *ngFor="let validation of errorMessages.OsobaID">
            <span
              class="error-message"
              *ngIf="fc.OsobaID.hasError(validation.type)"
            >
              <span translate="{{ validation.message }}"></span>
            </span>
          </span>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <!-- Broj dana za godišnji odmor -->
      <div class="col-md-3">
        <yt-input
          [Type]="'text'"
          [Label]="'RESENJEZAGO.PRAVONAGOBROJDANA.SINGULAR'"
          formControlName="PravoNaGoBrojDana"
          [ngClass]="{
            'is-invalid': submitted && fc.PravoNaGoBrojDana.invalid
          }"
          formControlName="PravoNaGoBrojDana"
        >
        </yt-input>
        <div
          class="form-error"
          *ngIf="submitted && fc.PravoNaGoBrojDana.invalid"
        >
          <span *ngFor="let validation of errorMessages.PravoNaGoBrojDana">
            <span
              class="error-message"
              *ngIf="fc.PravoNaGoBrojDana.hasError(validation.type)"
            >
              <span translate="{{ validation.message }}"></span>
            </span>
          </span>
        </div>
      </div>
      <!-- Godina na koju se odnosi godišnji odmor -->
      <div class="col-md-3">
        <yt-input
          [Type]="'text'"
          [Label]="'RESENJEZAGO.GODINA.SINGULAR'"
          formControlName="Godina"
          [ngClass]="{ 'is-invalid': submitted && fc.Godina.invalid }"
          formControlName="Godina"
        >
        </yt-input>
        <div class="form-error" *ngIf="submitted && fc.Godina.invalid">
          <span *ngFor="let validation of errorMessages.Godina">
            <span
              class="error-message"
              *ngIf="fc.Godina.hasError(validation.type)"
            >
              <span translate="{{ validation.message }}"></span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <yt-deo-za-resenje-za-go-update-container
          #baseInlineContainer
          [DetailModelData]="modelData.MainList.DetailList[0]"
          [ParentPropertyName]="'ResenjeZaGoID'"
          [ParentPropertyValue]="Item.ID"
          [Parameters]="TransferParameters"
        >
        </yt-deo-za-resenje-za-go-update-container>
      </div>
    </div>
  </form>
</div>
